import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Layout } from "../components/Layout";
import { Contact } from "../components/contact";
import { useSEO } from "../hooks/useSEO";

export const ContactPage = ({ data }) => {
  useSEO({
    title: "Contact Transwave Shipping Dubai | +971 50 417 3911",
    description:
      "Contact Transwave Shipping and Logistics LLC in Dubai, UAE. Call +971 50 417 3911, email info@transwaveshipping.com, or send a message for a free freight quote.",
    canonical: "https://www.transwaveshipping.com/contact",
  });

  return (
    <Layout contactData={data.Contact}>
      {/* Page Hero — split: headline left, quick-contact cards right */}
      <div className="page-hero page-hero--contact">
        <div className="container">
          <div className="page-hero-split">
            <motion.div
              className="page-hero-text"
              initial={{ opacity: 0, x: -30 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
            >
              <nav className="page-breadcrumb" aria-label="breadcrumb">
                <Link to="/">Home</Link> <span>/</span> <span>Contact</span>
              </nav>
              <h1>Contact Us</h1>
              <p>Get in touch for a shipping quote or logistics consultation</p>
            </motion.div>
            <motion.div
              className="page-hero-contact-cards"
              initial={{ opacity: 0, x: 30 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              {data.Contact?.phone && (
                <div className="hero-contact-card">
                  <i className="fa fa-phone"></i>
                  <a href={`tel:${data.Contact.phone.replace(/\s/g, "")}`}>{data.Contact.phone}</a>
                </div>
              )}
              {data.Contact?.email && (
                <div className="hero-contact-card">
                  <i className="fa fa-envelope-o"></i>
                  <a href={`mailto:${data.Contact.email}`}>{data.Contact.email}</a>
                </div>
              )}
              {data.Contact?.address && (
                <div className="hero-contact-card">
                  <i className="fa fa-map-marker"></i>
                  <span>{data.Contact.address}</span>
                </div>
              )}
            </motion.div>
          </div>
        </div>
      </div>

      <Contact data={data.Contact} />
    </Layout>
  );
};
